import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    LineElement
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


export default function LineChart({ data, title, left }) {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const { y, value, league } = context.raw;
                        return `${league}: ${y}%  (${value})`;
                    },
                },
            },
            legend: {
                display: false,
                position: 'top'
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 20,
                },
                color: '#fff'
            }, datalabels: { display: false }
        },
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    font: {
                        size: 16,
                    },
                    color: '#fff'
                },
                stacked: true,
            },
            y: {
                beginAtZero: true,
                max: 100,
                ticks: {
                    callback: function (value) {
                        return value + '%';
                    },
                    color: '#fff'
                },
                stacked: true,
            }
        }
    };
    return (
        <div className='graph' Style={left && 'margin-right: auto; margin-left: 5% '} >
            <Line data={data} options={options} />
        </div >
    );
}
